/* Sugo Mod 2026-09-22: applica gli effetti solo ai link testuali semplici, inclusi quelli aggiunti dinamicamente. */
(() => {
  const effect = document.currentScript?.dataset.effect;
  if (!['underline', 'slide', 'bold'].includes(effect)) return;

  const prepare = (root) => {
    const links = root instanceof HTMLAnchorElement ? [root] : root.querySelectorAll?.('a[href]') ?? [];

    for (const link of links) {
      if (link.hasAttribute('data-text-link-effect')) continue;
      if (link.matches('[role="button"], .button, .button-secondary, .button-custom, .button-unstyled, [class*="__button"]')) continue;
      if (link.querySelector('svg, img, picture, video, canvas, button, input, select')) continue;
      if (!link.textContent.trim()) continue;

      if (effect === 'slide' || effect === 'bold') {
        const host = link.children.length === 1 && link.firstElementChild?.tagName === 'SPAN' && !link.firstElementChild.children.length
          ? link.firstElementChild
          : link;
        const textNodes = [...host.childNodes].filter((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
        if (textNodes.length !== 1 || (host === link && link.children.length)) continue;

        const original = document.createElement('span');
        original.className = effect === 'slide' ? 'text-link-slide-original' : 'text-link-bold-original';
        original.textContent = textNodes[0].textContent;

        const copy = document.createElement('span');
        copy.className = effect === 'slide' ? 'text-link-slide-copy' : 'text-link-bold-copy';
        copy.textContent = original.textContent;
        copy.setAttribute('aria-hidden', 'true');

        const mask = document.createElement('span');
        mask.className = effect === 'slide' ? 'text-link-slide-mask' : 'text-link-bold-mask';
        mask.append(original, copy);
        textNodes[0].replaceWith(mask);
      }

      link.dataset.textLinkEffect = effect;
    }
  };

  prepare(document);
  document.addEventListener('shopify:section:load', (event) => prepare(event.target));

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node instanceof Element) prepare(node);
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
